import { render, staticRenderFns } from "./ContactPage.vue?vue&type=template&id=9a0d9bb8"
import script from "./ContactPage.vue?vue&type=script&lang=js"
export * from "./ContactPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BreadcrumbNavigation: require('/vercel/path0/components/shared/BreadcrumbNavigation.vue').default,ContainerContent: require('/vercel/path0/components/shared/ContainerContent.vue').default,ContactForm: require('/vercel/path0/components/shared/ContactForm.vue').default,PhoneIcon: require('/vercel/path0/components/icons/PhoneIcon.vue').default,MailIcon: require('/vercel/path0/components/icons/MailIcon.vue').default,HomeIcon: require('/vercel/path0/components/icons/HomeIcon.vue').default,GoogleMap: require('/vercel/path0/components/shared/GoogleMap.vue').default})
